$(function(){
  $("#shipping-estimator-country").on("change", function(e){
    let provinces = $(this).children("option:selected").data("provinces");
    let dropdown = document.querySelector("#shipping-estimator-province");

    dropdown.options.add(new Option("", ""));
    for(let i=0; i<provinces.length; i++){
      if (provinces[i][1] == "Metro Manila" || provinces[i][1] == "Cebu")
        dropdown.options.add(new Option(provinces[i][1], provinces[i][0]));
    }
  });
  $("#shipping-estimator-country").trigger("change");

  var barangays = [];
  $("#shipping-estimator-province").on("change", function(e){
    let province = $(this).val();

    $("#shipping-estimator-city").empty();
    if (province != "Metro Manila") {
      let cities = citiesList[province.toLowerCase()] || [];
      
      let cityOptions = '<option></option>';
      let barangayOptions;
      if (cities) {
        $.each(cities, (k, v) => {
          cityOptions += `<option value="${k}">${k}</option>`;
          barangays[k] = v;
        });
      }

      $("#city-placeholder, #barangay-placeholder").show();
      $("#shipping-estimator-city").html(cityOptions); 
      
    } else {
      $("#city-placeholder, #barangay-placeholder").hide();
    }
  });

  $("#shipping-estimator-city").on("change", function(e){
    let city = $(this).val();
    let brgy = barangays[city] || [];

    $("#shipping-estimator-barangay").empty();

    let barangayArr = [];
    let barangayOptions = '<option></option>';
    if (brgy) {
      $.each(brgy, (k, v) => {
        // if (v.status != 'OSA')
        //   barangayOptions += `<option value="${v.name}">${v.name}</option>`;

        barangayArr.push([v.name, v.status]);
        // barangayOptions += `<option value="${v.name}" ` + (v.status == "OSA" ? "disabled" : "") + `>${v.name}</option>`;
      });

      barangayArr.sort();
      barangayOptions = barangayArr.map(v => `<option value="${v[0]}" ${(v[1] == 'OSA' ? "disabled" : "")}>${v[0]}</option>`);
    }
    // $("#shipping-estimator-barangay").html(barangayOptions);
    $("#shipping-estimator-barangay").html(barangayOptions);
 });
  
  $('button[data-action="estimate-shipping"]').on("click touch", function(){

    let $this = $(this);
    let country = $("#shipping-estimator-country").val();
    let province = $("#shipping-estimator-province").val();
    let city = $("#shipping-estimator-city").val();
    let barangay = $("#shipping-estimator-barangay").val();
    let zip = $("#shipping-estimator-zip").val();

    // clear estimated amount
    $("#shipping-fee").html("0.00");

    // hide error message
    $("#limit_exceed_alert").addClass("d-none");

    // clear field error messages
    $(".error-label small").removeClass(".text-red").empty();

    // province validation
    if (province == "") {
      $("#error_province small").addClass("text-red").text("Please select a province");      
      return false;
    }

    // Skip City and Barangay validation for Metro Manila
    if (province != 'Metro Manila') {
      // city validation
      if (! city) {
        $("#error_city small").addClass("text-red").text("Please select a city");      
        return false;
      }
  
      // barangay validation
      if (! barangay) {
        $("#error_barangay small").addClass("text-red").text("Please select a barangay");      
        return false;
      }
    }

    // zip code validation
    if (zip == "") {
      $("#error_zip small").addClass("text-red").text("Please enter a zip code");      
      return false;
    }

    let estimates = "".concat(window.Theme.routes.cart_url, `/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);

    // disable Estimate button
    $this.attr('disabled', 'disabled').addClass("btn-disabled");

    fetch(estimates, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      if (response.ok) {
        response.json().then(function(result){
            if (result.shipping_rates.length === 0) {    
              $("#limit_exceed_alert").removeClass("d-none");
            } else {            
              let { price } = result.shipping_rates[1];              
              let tx = parseInt(12);
              let tax = tx / 100;
              // let charges = (parseInt(price) + (parseInt(price) * tax)).toFixed(2);
              let charges = parseInt(price).toFixed(2);

              $("#shipping-fee").html(charges);
              $(".shipping-estimator__results").show();
            }
        });    
      }
      $this.removeAttr('disabled').removeClass("btn-disabled");
      
    }).catch(error => {
      $this.removeAttr('disabled').removeClass("btn-disabled");
      console.log(error);
    });  
  });
});